import { useQuery } from '@tanstack/react-query'

import { ClientLocationThemesService } from '@services/client_location_themes.service'
import { LocationThemeClientDto } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientLocationTheme = (locationName: string) => {
  return useQuery<LocationThemeClientDto>({
    queryKey: ['clientLocationTheme', locationName],
    queryFn: () => ClientLocationThemesService.getTheme(locationName),
    ...defaultQueryOptions,
  })
}
